import { ElementRef, Injectable, inject } from '@angular/core';

// Used to reskin common components and their overlay panels.
@Injectable()
export class DesignSystemsReskinUtility {
  private readonly hostElement = inject<ElementRef<HTMLElement>>(ElementRef);

  get reskinPanelClass(): string {
    return this.hostElement.nativeElement.closest('.design-systems-reskin-compact')
      ? 'design-systems-reskin-compact-panel'
      : '';
  }
}
